/**
 * Минимальный интерфейс storage backend'а как его ожидает redux-persist.
 */
export interface StorageBackend {
  getItem(key: string): Promise<string | null> | string | null
  setItem(key: string, value: string): Promise<void> | void
  removeItem(key: string): Promise<void> | void
}

// function normalizeStorageBackend(mod: unknown): StorageBackend {
//   const candidate = (mod as { default?: unknown })?.default ?? mod
//   const backend = candidate as Partial<StorageBackend>
//   if (
//     typeof backend.getItem === 'function' &&
//     typeof backend.setItem === 'function' &&
//     typeof backend.removeItem === 'function'
//   ) {
//     return backend as StorageBackend
//   }

  // Fallback for environments where storage adapter import shape differs.
  // Keeps app functional without crashing persist initialization.
//   return {
//     getItem: () => null,
//     setItem: () => {},
//     removeItem: () => {},
//   }
// }

/**
 * Defensive wrapper фабрика.
 */
export function createSafeStorage(backend: StorageBackend): StorageBackend {
  return {
    getItem: async (key: string): Promise<string | null> => {
      let raw: string | null
      try {
        raw = (await backend.getItem(key)) ?? null
      } catch {
        try { await backend.removeItem(key) } catch { /* ignore */ }
        return null
      }
      if (raw == null || raw === '') {
        if (raw === '') {
          try { await backend.removeItem(key) } catch { /* ignore */ }
        }
        return null
      }

      try {
        const outer = JSON.parse(raw) as Record<string, unknown>
        for (const value of Object.values(outer)) {
          if (typeof value === 'string') {
            JSON.parse(value)
          }
        }
      } catch {
        try { await backend.removeItem(key) } catch { /* ignore */ }
        return null
      }

      return raw
    },
    // Делаем методы async, чтобы они всегда возвращали Promise
    setItem: async (key, value) => {
      try {
        await backend.setItem(key, value)
      } catch (e) {
        console.error('[SafeStorage] setItem error:', e)
      }
    },
    removeItem: async (key) => {
      try {
        await backend.removeItem(key)
      } catch (e) {
        console.error('[SafeStorage] removeItem error:', e)
      }
    },
  }
}

const localStorageBackend: StorageBackend = {
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),
}

export const safeStorage = createSafeStorage(localStorageBackend)
